import React from 'react'
import queryString from 'query-string'
import FallbackImage from '../FallbackImage'
import I18n from '../../lib/i18n'

const CheatCodesGrid = (props, context) => {
  const { mobile_medium_url, name, url } = props.item
  const query = url.indexOf('?') !== -1 ? url.split('?')[1] : ''
  const params = queryString.parse(query)
  const _onClick = () => {
    props.onClick({ params })
  }
  const cheat_code = params && params.q

  return <div className='cheat-code-grid grid col-6' onClick={_onClick}>
    <FallbackImage
      className='cheat-code-image image'
      fallback_className='image-default'
      src={mobile_medium_url}
      alt={`hot-item-${name}`}
    />
    { cheat_code && <div className='cheat-code-label-wrapper'><div className='cheat-code-label'>{cheat_code}</div></div> }
    {
      name.split('|').map((word, index) => <div className='product-item-name'>
        { word }
      </div>)
    }
    { params && params.label && <div className='product-group-label'>{I18n.t(`labels.${params.label}`)}</div> }
  </div>
}

export default CheatCodesGrid



// WEBPACK FOOTER //
// ./src/components/Grid/CheatCodesGrid.js